import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { LinkButton, SecondaryButton } from "../../../common/Buttons";
import EmergencyFolderOrdinance from "./EmergencyFolderOridinance";

const EmergencyFolder = ({ next, pre, setButtonDisabled, buttonDisabled }) => {
  const { t } = useTranslation();

  return (
    <>
      <EmergencyFolderOrdinance
        next={next}
        pre={pre}
        setButtonDisabled={setButtonDisabled}
      />
      <div
        style={{
          minWidth: "310px",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <SecondaryButton
          title={t("save-and-continue")}
          bgColor="#E8D7E5"
          borderRadius="14px"
          width="180px"
          marginLeft="20px"
          border="none"
          hoverBgColor="color.magentaLight1"
          textTransform="initial"
          padding="0rem"
          height="2.7rem"
          form="form_submit"
          type="submit"
          disabled={buttonDisabled}
        />
        <LinkButton
          title={t("skip-for-now")}
          bgColor="color.transparent"
          borderRadius="14px"
          fontSize="0.8rem"
          width="100px"
          padding="0"
          marginLeft="10px"
          border="none"
          click={() => next()}
          textTransform="initial"
        />
      </div>
    </>
  );
};

export default EmergencyFolder;
